
import TableList from "@components/templates/tablelist";
import { HttpSerialNoList, HttpSerialNoCannel } from '@/service/boss/allot';
import { mapState, mapGetters } from "vuex";
import compUpdate from './update';
export default {
    mixins: [TableList],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    created(){
        this.channelProductDel = this.handleAuth('erp.channelProductSerialNos.del');
    },
    methods: {
        ajaxRequest: HttpSerialNoList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: "添加" }),
                        component: 'compUpdate',
                        show: true,
                        width: 'middle',
                        showFooter: false,
                    }; break;
                case "del":
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: {
                            status: 1,
                            ids: params
                        },
                        title: this.$t('erp.product.operate_delete', { defaultValue: "删除操作" }),
                        ajaxRequest: HttpSerialNoCannel
                    }
                    break;
                case "upload":
                    this.operate = {
                        show: true,
                        title: this.$t('erp.b2c.import_data',{defaultValue:'导入数据'}),
                        showDesc: false,
                        component: "compUpload",
                        name: "excelFile",
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/ChannelProductSerialNos/import",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/ChannelProductSerialNos/excel', {}, 'download')
                        },
                    };
                    break;
            }
        },
    },
    computed: {
        ...mapState('boss', ['accounts']),
        ToolsData() {
            return [
                {
                    label: this.$t('erp.product.new_add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                },
                {
                    label: this.$t('global.common.import',{defaultValue:'导入'}),
                    operate: "upload",
                    theme: "info",
                },
                {
                    label: this.$t("global.common.delete",{defaultValue:'删除'}),
                    operate: "del",
                    theme: "gray",
                    batch: true,
                    hidden:!this.channelProductDel
                },
            ]
        },

        getAccountList() {
            const arr = []
            this.accounts.forEach(item => {
                if (item.type === 'amazon') {
                    arr.push({
                        value: item.flag,
                        label: item.flag
                    })
                }
            });
            return arr.sort(function(a,b){
                return a.value.localeCompare(b.value)
            })
        },

        SearchsData() {
            return [
                {
                    show: true,
                    label: this.$t("erp.shopname.account",{defaultValue:'店铺账号'}),
                    key: 'EQ_channelFlag',
                    tag: 'vSelect',
                    options: this.getAccountList,
                    props: {
                        filterable: true,
                    }
                }, {
                    show: true,
                    label: 'Seller SKU',
                    key: 'EQ_sellerSku',
                    tag: 'vInput',
                }, {
                    show: true,
                    label: this.$t('erp.serialNos.index',{defaultValue:'序列号'}),
                    key: 'EQ_serialNo',
                    tag: 'vInput',
                }, {
                    label: this.$t('erp.istakeup.tip',{defaultValue:'是否占用'}),
                    key: 'EQ_isUsed',
                    tag: 'vSelect',
                    options: [{
                        value: 1,
                        label: this.$t('global.common.yes',{defaultValue:'是'})
                    }, {
                        value: 0,
                        label: this.$t('global.common.no',{defaultValue:'否'})
                    }],
                }, {
                    label: this.$t('erp.sale.orderid',{defaultValue:'关联订单号'}),
                    key: 'EQ_saleOrderId',
                    tag: 'vInput',
                }, {
                    label: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    key: 'BT_createdAt',
                    tag: 'vDatepicker',
                    style: "width:362px",
                    props: {
                        placeholder: "Select date",
                        format: 'yyyy-mm-dd 00:00:00 ~ yyyy-mm-dd 23:59:59',
                        confirm: false,
                    }
                },
            ]
        },

        columns() {
            return [{
                width: 60,
                align: 'center',
                type: "selection",
                formName: 'id',
            },
            {
                title: this.$t("erp.shopname.account",{defaultValue:'店铺账号'}),
                key: "channelFlag",
            },
            {
                title: 'Seller Sku',
                key: 'sellerSku',
            },
            {
                title: this.$t('erp.serialNos.index',{defaultValue:'序列号'}),
                key: "serialNo",
            },
            {
                title: this.$t('erp.istakeup.tip',{defaultValue:'是否占用'}),
                width: 90,
                align: 'center',
                key: "isUsed",
                render: (h, { row }) => {
                    return row.isUsed == 1 ? <span class='padding-5 bg-error color-white'>{this.$t('global.common.yes',{defaultValue:'是'})}</span> : <span class='padding-5 bg-primary color-white'> {this.$t('global.common.no',{defaultValue:'否'})}</span>
                }
            },
            {
                title: this.$t('erp.sale.orderid',{defaultValue:'关联订单号'}),
                key: "saleOrderId",
                align: 'center',
                render: (h, { row }) => {
                    return row.saleOrderId == 0 ? '--' : row.saleOrderId
                }
            },
            {
                title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                key: "createdAt",
            },
            {
                title: this.$t('global.common.operation',{defaultValue:'操作'}),
                    width: 100,
                render: (h, { row }) => {
                const id = row.id;
                return <div>
                    <vButton class="margin-right-15" theme="gray" onClick={this.handleOperates.bind(this, id, 'del')}>{this.$t("global.common.delete",{defaultValue:'删除'})}</vButton>
                </div>
                }
            }]
        },

    },

};
